// extracted by mini-css-extract-plugin
module.exports = {"close":"QSRCloseButton_close__sKL0g","icon":"QSRCloseButton_icon__lpCgp","dark":"QSRCloseButton_dark__UdpMD","light":"QSRCloseButton_light__j_ADP"};